export interface NavLink {
    label: string
    href: string
    external?: boolean
}

export interface FooterColumn {
    title: string
    links: NavLink[]
}

export const RAYCAST_URL = 'https://www.raycast.com'
export const DOWNLOAD_URL = 'https://www.raycast.com/download'
export const SIGN_IN_URL = 'https://www.raycast.com/users/sign_in'
export const LAUNCH_VIDEO_ID = '73pdeHCGerA'

export const NAV_LINKS: NavLink[] = [
    { label: 'Store', href: 'https://www.raycast.com/store' },
    { label: 'Pro', href: 'https://www.raycast.com/pro' },
    { label: 'AI', href: 'https://www.raycast.com/core-features/ai' },
    { label: 'iOS', href: 'https://www.raycast.com/ios' },
    { label: 'Windows', href: 'https://www.raycast.com/windows' },
    { label: 'Teams', href: 'https://www.raycast.com/teams' },
    { label: 'Enterprise', href: 'https://www.raycast.com/enterprise' },
    { label: 'Blog', href: 'https://www.raycast.com/blog' },
    { label: 'Pricing', href: 'https://www.raycast.com/pricing' }
]

export const FOOTER_COLUMNS: FooterColumn[] = [
    {
        title: 'Product',
        links: [
            { label: 'Store', href: 'https://www.raycast.com/store' },
            { label: 'Pro', href: 'https://www.raycast.com/pro' },
            { label: 'Teams', href: 'https://www.raycast.com/teams' },
            { label: 'Pricing', href: 'https://www.raycast.com/pricing' },
            { label: 'Changelog', href: 'https://www.raycast.com/changelog' },
            { label: 'Browser Extension', href: 'https://www.raycast.com/browser-extension' },
            { label: 'Developers', href: 'https://www.raycast.com/developers' },
            { label: 'iOS', href: 'https://www.raycast.com/ios' },
            { label: 'Windows', href: 'https://www.raycast.com/windows' },
            { label: 'Raycast 2.0', href: 'https://www.raycast.com/new' },
            { label: 'API Docs', href: 'https://developers.raycast.com', external: true },
            { label: 'Manual', href: 'https://www.raycast.com/manual', external: true },
            { label: 'Troubleshooting', href: 'https://www.raycast.com/troubleshooting', external: true },
            { label: 'Raycast vs Alfred', href: 'https://www.raycast.com/raycast-vs-alfred' },
            { label: 'FAQ', href: 'https://www.raycast.com/faq' }
        ]
    },
    {
        title: 'Core Features',
        links: [
            { label: 'Raycast AI', href: 'https://www.raycast.com/core-features/ai' },
            { label: 'Raycast Notes', href: 'https://www.raycast.com/core-features/notes' },
            { label: 'Raycast Focus', href: 'https://www.raycast.com/core-features/focus' },
            { label: 'Clipboard History', href: 'https://www.raycast.com/core-features/clipboard-history' },
            { label: 'Window Management', href: 'https://www.raycast.com/core-features/window-management' },
            { label: 'Snippets', href: 'https://www.raycast.com/core-features/snippets' },
            { label: 'File Search', href: 'https://www.raycast.com/core-features/file-search' },
            { label: 'Quicklinks', href: 'https://www.raycast.com/core-features/quicklinks' },
            { label: 'Calculator', href: 'https://www.raycast.com/core-features/calculator' },
            { label: 'Calendar', href: 'https://www.raycast.com/core-features/calendar' },
            { label: 'System', href: 'https://www.raycast.com/core-features/system' },
            { label: 'Emoji Picker', href: 'https://www.raycast.com/core-features/emoji-picker' }
        ]
    },
    {
        title: 'Top Extensions',
        links: [
            { label: 'Design Tools', href: 'https://www.raycast.com/store/category/design-tools' },
            { label: 'Developer Tools', href: 'https://www.raycast.com/store/category/developer-tools' },
            { label: 'Pomodoro Timer', href: 'https://www.raycast.com/store/category/pomodoro-timer' },
            { label: 'Productivity', href: 'https://www.raycast.com/store/category/productivity' },
            { label: 'Project Management', href: 'https://www.raycast.com/store/category/project-management' },
            { label: 'Time Management', href: 'https://www.raycast.com/store/category/time-management' },
            { label: 'Transcript', href: 'https://www.raycast.com/store/category/transcript' },
            { label: 'Translation', href: 'https://www.raycast.com/store/category/translation' },
            { label: 'Work From Home', href: 'https://www.raycast.com/store/category/work-from-home' },
            { label: 'AI', href: 'https://www.raycast.com/store/category/ai' }
        ]
    },
    {
        title: 'Company',
        links: [
            { label: 'Manifesto', href: 'https://www.raycast.com/why' },
            { label: 'Customers', href: 'https://www.raycast.com/customers' },
            { label: 'Careers', href: 'https://www.raycast.com/careers' },
            { label: 'Terms of Service', href: 'https://www.raycast.com/terms-of-service' },
            { label: 'Privacy Policy', href: 'https://www.raycast.com/privacy' },
            { label: 'Acceptable Use Policy', href: 'https://www.raycast.com/aup' },
            { label: 'DPA', href: 'https://www.raycast.com/dpa' },
            { label: 'Trust Center', href: 'https://trust.raycast.com', external: true },
            { label: 'Press Kit', href: 'https://www.raycast.com/press' },
            { label: 'Contact', href: 'https://www.raycast.com/feedback' }
        ]
    },
    {
        title: 'Community',
        links: [
            { label: 'Community Stories', href: 'https://www.raycast.com/community-stories' },
            { label: 'Ambassadors', href: 'https://www.raycast.com/ambassadors' },
            { label: 'Slack', href: 'https://www.raycast.com/community' },
            { label: 'X/Twitter', href: 'https://twitter.com/raycast', external: true },
            { label: 'GitHub', href: 'https://github.com/raycast', external: true },
            { label: 'Dribbble', href: 'https://www.dribbble.com/raycastapp', external: true }
        ]
    },
    {
        title: 'By Raycast',
        links: [
            { label: 'Keyboard', href: '/' },
            { label: 'Glaze', href: 'https://glaze.app', external: true },
            { label: 'Explore Snippets', href: 'https://ray.so/snippets', external: true },
            { label: 'Explore Quicklinks', href: 'https://ray.so/quicklinks', external: true },
            { label: 'Prompts', href: 'https://ray.so/prompts', external: true },
            { label: 'Chat Presets', href: 'https://ray.so/presets', external: true },
            { label: 'ray.so', href: 'https://www.ray.so', external: true },
            { label: 'Icon Maker', href: 'https://ray.so/icon', external: true },
            { label: 'Merch', href: 'https://merch.raycast.com', external: true },
            { label: 'Wallpapers', href: 'https://www.raycast.com/wallpapers' }
        ]
    }
]
